var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 12.0313C6.3275 12.0313 2.25 13.055 2.25 15.0938V16.625H14.5V15.0938C14.5 13.055 10.4225 12.0313 8.375 12.0313ZM4.2975 14.875C5.0325 14.3675 6.80875 13.7813 8.375 13.7813C9.94125 13.7813 11.7175 14.3675 12.4525 14.875H4.2975ZM8.375 10.5C10.0637 10.5 11.4375 9.12625 11.4375 7.4375C11.4375 5.74875 10.0637 4.375 8.375 4.375C6.68625 4.375 5.3125 5.74875 5.3125 7.4375C5.3125 9.12625 6.68625 10.5 8.375 10.5ZM8.375 6.125C9.10125 6.125 9.6875 6.71125 9.6875 7.4375C9.6875 8.16375 9.10125 8.75 8.375 8.75C7.64875 8.75 7.0625 8.16375 7.0625 7.4375C7.0625 6.71125 7.64875 6.125 8.375 6.125ZM14.535 12.0838C15.55 12.8188 16.25 13.7988 16.25 15.0938V16.625H19.75V15.0938C19.75 13.3263 16.6875 12.32 14.535 12.0838ZM13.625 10.5C15.3138 10.5 16.6875 9.12625 16.6875 7.4375C16.6875 5.74875 15.3138 4.375 13.625 4.375C13.1525 4.375 12.715 4.48875 12.3125 4.68125C12.8638 5.46 13.1875 6.41375 13.1875 7.4375C13.1875 8.46125 12.8638 9.415 12.3125 10.1937C12.715 10.3863 13.1525 10.5 13.625 10.5Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPeopleIcon);
export default __webpack_public_path__ + "static/media/default-people-icon.d61a7b57160743a5cec8ef6ad385448f.svg";
export { ForwardRef as ReactComponent };